module.exports = __webpack_public_path__ + "static/img/recent-page-empty.042773f7.svg";